import type { SavedBucketTestType } from 'store/types'

export const SAVED_BUCKET_TEST_TYPES: SavedBucketTestType[] = [
  'POX_COX',
  'POX_COX_HST',
  'HST',
  'PSG',
  'ALL',
]

const savedBucketTestTypeLabelMap: Record<SavedBucketTestType, string> = {
  POX_COX: 'PulseOx-CapOx',
  POX_COX_HST: 'PulseOx-CapOx + HST',
  HST: 'Home Sleep Testing',
  PSG: 'In-Lab Sleep Testing',
  ALL: 'All Test Types',
}

export const normalizeSavedBucketTestType = (
  testType?: string,
): SavedBucketTestType | null => {
  if (!testType) return null

  const normalized = testType.toUpperCase()

  if (SAVED_BUCKET_TEST_TYPES.includes(normalized as SavedBucketTestType)) {
    return normalized as SavedBucketTestType
  }

  if (normalized === 'POX,COX') return 'POX_COX'
  if (normalized === 'POX,COX,HST') return 'POX_COX_HST'
  if (normalized === 'POX,COX,HST,PSG') return 'ALL'

  return null
}

export const getSavedBucketTestTypeLabel = (testType: SavedBucketTestType): string =>
  savedBucketTestTypeLabelMap[testType] || testType
